import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import http from "./http";

if (typeof Node === 'function' && Node.prototype) {
    const originalRemoveChild = Node.prototype.removeChild;
    // @ts-ignore
    Node.prototype.removeChild = function (child) {
        if (child.parentNode !== this) {
            if (console) {
                console.warn('Cannot remove a child from a different parent', child, this);
            }
            return child;
        }
        // @ts-ignore
        return originalRemoveChild.apply(this, arguments);
    };

    const originalInsertBefore = Node.prototype.insertBefore;
    // @ts-ignore
    Node.prototype.insertBefore = function (newNode, referenceNode) {
        if (referenceNode && referenceNode.parentNode !== this) {
            if (console) {
                console.warn(
                    'Cannot insert before a reference node from a different parent',
                    referenceNode,
                    this
                );
            }
            return newNode;
        }
        // @ts-ignore
        return originalInsertBefore.apply(this, arguments);
    };
}

let appVersion = ''

http.get<{ version: string }>('api/version')
    .then(res => appVersion = res.data.version)
    .catch(() => appVersion = 'unknown')

setInterval(() => {
    http.get<{ version: string }>('api/version')
        .then(res => {
            if(res.data.version === appVersion) return
            window.location.reload()
        })
}, 60000)

ReactDOM.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
